import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { SessionUser } from "src/app/shared/models/sessionUser";
import Swal from "sweetalert2";
import * as moment from "moment";
import { PagoUsuarioService } from "src/app/services/pago-usuario.service";
import { CertificadoCompraWizard } from "src/app/models/Emisor/EmisorWizardRequest";

@Component({
	selector: "app-payment-emisor",
	templateUrl: "./payment-emisor.component.html",
	styleUrls: ["./payment-emisor.component.scss"],
})
export class PaymentEmisorComponent implements OnInit {
	public planSeleccionado: Plan;
	@Input() public idPlanUsuario: string;
	public loading: boolean = false;

	@Output() public actualizarCertificaciones: EventEmitter<any> = new EventEmitter<any>();
	@Output() public actualizarResumen: EventEmitter<Resumen> = new EventEmitter<Resumen>();

	@Input() public compraCertificado: CertificadoCompraWizard;


	public planes: Plan[];
	public certificaciones: CertificacionPrecio[];
	public user: SessionUser;
	public idContratacion: string;

	//@Input() public type: string;
	public planUsuarioPagado: PlanUsuario;

	constructor(private planUsuarioService: PlanUsuarioService, private pagoService: PagoUsuarioService, private userService: UsuarioService, private tokenService: TokenStorageService, private ref: ChangeDetectorRef) {
		this.user = this.tokenService.getUser() as SessionUser;
	}

	ngOnInit(): void {
		this.loading = true;
		this.planUsuarioService.getInitialData().subscribe((data) => {
			//this.planes = data.planes;
			this.planes = data.planes.filter(plan => plan.antiguedad === 'Nuevo');
			this.certificaciones = data.certificaciones;
			const idEmpresa = this.tokenService.getCompany();
			this.userService.getUser(this.user.id, this.user.configured ? idEmpresa : null).subscribe((response) => {
				this.handleUserData(response.data);
			}, this.handleError);

			this.loading = false;
			this.ref.detectChanges();
		});
	}

	handleUserData(userData: any): void {
		let planActual: PlanUsuario;
		if (this.idPlanUsuario != null && this.idPlanUsuario != undefined) {
			//Existe un plan
			planActual = userData.planesUsuario.find((y) => y.idPlanUsuario === this.idPlanUsuario);
			this.certificaciones.forEach((x) => {
				x.solicitada = false;
			});
			userData.certificacionesPendientes.forEach((x) => {
				let certTemp = this.certificaciones.find((z) => z.codigoPrincipal === x.codigoPrincipal);
				certTemp.solicitada = true;
			});
			this.handlePlanActual(userData, planActual);
		} else {
			//Es posible que el IdUsuario esté dentro de los planes del usuario
			planActual = userData.planesUsuario[0];
			//planActual.pagado = false;
			this.handlePlanActual(userData, planActual);
		}
		if (!this.user.configured && planActual && planActual.pagado && !planActual.activo) {
			let resumenCuenta = new Resumen();
			resumenCuenta.pagado = planActual.pagado;
			resumenCuenta.idPlanUsuario = planActual.idPlanUsuario;
			resumenCuenta.idPlanSf = planActual.idPlanSf;
			resumenCuenta.formaPago = planActual.formaPago;
			resumenCuenta.nombrePlan = planActual.nombrePlan;
			resumenCuenta.meses = planActual.meses;
			this.pagoService.triggerCalculations();
			this.notifyResumen(resumenCuenta);
		}
		this.actualizarCertificaciones.emit(this.certificaciones);
	}

	handlePlanActual(userData: any, planActual: PlanUsuario): void {
		this.planUsuarioPagado = planActual;
		if (planActual && !planActual.activo) {
			this.planSeleccionado = this.planes.find((x) => x.nombre === planActual.nombrePlan);
			this.idContratacion = planActual.idContratacion;
			this.idPlanUsuario = planActual.idPlanUsuario;
			this.certificaciones.forEach((x) => {
				x.idPlanUsuario = planActual.idPlanUsuario;
				x.solicitada = userData.certificacionesPendientes.some((y) => y.codigoPrincipal === x.codigoPrincipal);
			});
			this.ref.detectChanges();
		}
		setTimeout(() => {
			this.pagoService.triggerCalculations();
		}, 0);
		// TODO this.nmeses = planActual.meses;
		// TODO this.resumenCuenta.formaPago = planActual.formaPago;
	}

	// setPlanActualValues(planActual: PlanUsuario): void {
	// 	this.planSeleccionado = this.planes.find((x) => x.id === planActual.idPlanSf);
	// 	this.nmeses = planActual.meses > 0 ? planActual.meses : 6;
	// 	this.pagado = planActual.pagado;
	// 	//this.planUsuarioPagado = planActual;
	// }

	notifyResumen(resumen: Resumen): void {
		this.actualizarResumen.emit(resumen);
		//this.actualizarPlan.emit(this.planUsuarioPagado);
	}

	updatePlan(plan: Plan) {
		this.planSeleccionado = plan;

		if (this.user.isPartner) {
			let resumenCuenta = new Resumen();
			resumenCuenta.idPlanSf = plan.id;
			resumenCuenta.formaPago = "reseller";
			resumenCuenta.nombrePlan = plan.nombre;
			this.notifyResumen(resumenCuenta);
		}
		setTimeout(() => {
			this.pagoService.triggerCalculations();
		}, 0);
		//this.planUsuarioService.triggerCalculations();
	}

	handleError(error): void {
		Swal.fire({
			title: "Error en datos",
			text: "No fue posible obtener los datos del usuario actual, favor intente nuevamente",
			icon: "error",
		});
	}
}
